import { CommunicationService, CommunicationTableData, CommunicationServiceDependencies } from './types';
import { deiterateAPI } from '@/js/external-js/variableModules/utils/deiterateAPI.util';

interface ApiResponse<T> {
  statusCode: number;
  data: T;
}

export class CommunicationServiceImpl implements CommunicationService {
  async fetchCommunicationData(companyId: string): Promise<CommunicationTableData> {
    try {
      const response = await deiterateAPI.GET<ApiResponse<CommunicationTableData>>(
        `/v1/communication`,
        { backend: 'thalassa', companyID: companyId }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching communication data:', error);
      throw error;
    }
  }

  async updateCommunicationData(
    companyId: string,
    data: Partial<CommunicationTableData>
  ): Promise<void> {
    try {
      await deiterateAPI.PUT(
        `/v1/communication`,
        { body: JSON.stringify(data), backend: 'thalassa', companyID: companyId }
      );
    } catch (error) {
      console.error('Error updating communication data:', error);
      throw error;
    }
  }

  async addNewFrequency(frequency: string, companyId?: string): Promise<void> {
    try {
      await deiterateAPI.POST(
        `/v1/communication/frequency`,
        { body: JSON.stringify({ frequency }), backend: 'thalassa', companyID: companyId }
      );
    } catch (error) {
      console.error('Error adding new frequency:', error);
      throw error;
    }
  }

  async addNewCommunicationChannel(channel: string, companyId?: string): Promise<void> {
    try {
      await deiterateAPI.POST(
        `/v1/communication/channel`,
        { body: JSON.stringify({ channel }), backend: 'thalassa', companyID: companyId }
      );
    } catch (error) {
      console.error('Error adding new communication channel:', error);
      throw error;
    }
  }
}

// Factory function to create the service (no longer requires Firebase dependencies)
export const createCommunicationService = (): CommunicationService => {
  return new CommunicationServiceImpl();
};

// Singleton instance - now auto-initialized since no deps needed
let communicationServiceInstance: CommunicationService | null = null;

export const getCommunicationService = (): CommunicationService => {
  if (!communicationServiceInstance) {
    communicationServiceInstance = createCommunicationService();
  }
  return communicationServiceInstance;
};

// Legacy init function for backwards compatibility (deps no longer needed)
export const initCommunicationService = (_deps?: CommunicationServiceDependencies): void => {
  if (!communicationServiceInstance) {
    communicationServiceInstance = createCommunicationService();
  }
};